const DATA_COUNT_PER_CARD = 4;

const getSlicedCardData = (data) => {
  return Array.isArray(data) ? data.slice(0, DATA_COUNT_PER_CARD) : [];
};

export { getSlicedCardData }